import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f5e4428"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "homeContainer" }
const _hoisted_2 = { class: "homeSelect" }
const _hoisted_3 = { class: "TotalDescription" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "serverChart" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "CPU usage",
    style: {"float":"left","width":"100%","height":"33%"}
  }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "memory usage",
    style: {"float":"left","width":"100%","height":"33%"}
  }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "disk usage",
    style: {"float":"left","width":"100%","height":"33%"}
  })
], -1))
const _hoisted_5 = { class: "infoDetails" }

import { homeAPI } from '@/api/home';
import { ServerInfo } from '@/store/modules/home/types'
import { onMounted, onUnmounted, ref, watch } from 'vue';
import * as echarts from "echarts";
import GetFileSize from "@/utils/fileSize";
import changeToDateTime from '@/utils/timestamp2DateTime';
import { ElMessage, ElMessageBox } from 'element-plus'
import type { Action } from 'element-plus'
import changeToTime from '@/utils/changeToTime';

import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: 'HomeWindow',
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const resSliceMap = ref<Map<string, ServerInfo[]>>(new Map())
const resSliceRef5min = ref<ServerInfo[]>([])
const resSliceRef1h = ref<ServerInfo[]>([])
const resSliceRef12h = ref<ServerInfo[]>([])
const resSliceRef1day = ref<ServerInfo[]>([])
const xDataRef = ref<string[]>([])
const isLoading = ref<boolean>(false)
const serverName = ref('web server')
const timeDuration = ref('5 minute')

const cpuUsage = ref<number[]>([])
const memoryUsage = ref<number[]>([])
const diskUsage = ref<number[]>([])
const intervalId = ref<number>(0)
const infoDetails = ref<ServerInfo>()
const infoDetailsList = ref<ServerInfo[]>([])
const options = [
    {
        value: 'web server',
        label: 'web server',
    },
    {
        value: 'file server',
        label: 'file server',
    },
]
const timeDurationOptions = [
    {
        value: '5 minute',
        label: '最近五分钟',
    },
    {
        value: '1 hour',
        label: '最近一小时',
    },
    {
        value: '0.5 day',
        label: '最近半天',
    },
    {
        value: '1 day',
        label: '最近一天',
    },
]

let distanceOfTimeDuration: Map<string, number> = new Map();
distanceOfTimeDuration.set('5 minute', 6)
distanceOfTimeDuration.set('1 hour', 60)
distanceOfTimeDuration.set('0.5 day', 720)
distanceOfTimeDuration.set('1 day', 1440)

let xAxisDataMap: Map<string, string[]> = new Map();
xAxisDataMap.set('5 minute', ['6', '5.5', '5', '4.5', '4', '3.5', '3', '2.5', '2', '1.5', '1', '0.5', '0'])
xAxisDataMap.set('1 hour', ['60', '55', '50', '45', '40', '35', '30', '25', '20', '15', '10', '5', '0'])
xAxisDataMap.set('0.5 day', ['12', '11', '10', '9', '8', '7', '6', '5', '4', '3', '2', '1', '0'])
xAxisDataMap.set('1 day', ['24', '22', '20', '18', '16', '14', '12', '10', '8', '6', '4', '2', '0'])

let xAxisNameMap: Map<string, string> = new Map();
xAxisNameMap.set('5 minute', '(min)')
xAxisNameMap.set('1 hour', '(min)')
xAxisNameMap.set('0.5 day', '(h)')
xAxisNameMap.set('1 day', '(h)')

const webServerProcess = async () => {
    let serverStatus = await homeAPI.checkServerStatus()
    if (serverStatus.memoryUsedPercent >= 80) {
        ElMessageBox.confirm(
            '当前内存占用已超过80%',
            '',
            {
                confirmButtonText: 'OK',
                type: 'warning',
            }
        )
    } else if (serverStatus.diskUsedPercent > 80) {
        ElMessageBox.confirm(
            '当前硬盘使用已超过80%',
            '',
            {
                showCancelButton: false,
                confirmButtonText: 'OK',
                type: 'warning',
            }
        )
    }

    let duration = distanceOfTimeDuration.get(timeDuration.value)
    if (duration !== undefined) {
        const res = await homeAPI.getServerInfoByDuration(duration)
        infoDetailsList.value = res
        setChartData13(res)
    }
}

const setChartData13 = (res: ServerInfo[]) => {
    if (res !== null && res.length !== 0) {
        let res0 = res[0]

        let zero = res[res.length - 1].timeStamp
        if (infoDetails.value !== undefined) {
            res0.readRate = res0.readTime === infoDetails.value.readTime ? 0 : (res0.readBytes - infoDetails.value.readBytes) / (res0.readTime - infoDetails.value.readTime)
            res0.writeRate = res0.writeTime === infoDetails.value.writeTime ? 0 : (res0.writeBytes - infoDetails.value.writeBytes) / (res0.writeTime - infoDetails.value.writeTime)
        } else {
            res0.readRate = 0
            res0.writeRate = 0
        }
        infoDetails.value = res0
        cpuUsage.value = []
        memoryUsage.value = []
        diskUsage.value = []
        xDataRef.value = []

        for (let i = res.length - 1; i >= 0; i--) {
            cpuUsage.value.push(JSON.parse(res[i].totalPercent)[0])
            memoryUsage.value.push(res[i].memoryUsedPercent)
            diskUsage.value.push(res[i].diskUsedPercent)
            xDataRef.value.push(getTimeDisplay(zero - res[i].timeStamp).toFixed(2))
        }
    }
}

// const setChartData = (resSlice: ServerInfo[]) => {
//     if (resSlice.length !== 0) {
//         let res = resSlice[0]
//         if (infoDetails.value !== undefined) {
//             res.readRate = res.readTime === infoDetails.value.readTime ? 0 : (res.readBytes - infoDetails.value.readBytes) / (res.readTime - infoDetails.value.readTime)
//             res.writeRate = res.writeTime === infoDetails.value.writeTime ? 0 : (res.writeBytes - infoDetails.value.writeBytes) / (res.writeTime - infoDetails.value.writeTime)
//         } else {
//             res.readRate = 0
//             res.writeRate = 0
//         }
//         infoDetails.value = res
//         cpuUsage.value = []
//         memoryUsage.value = []
//         diskUsage.value = []
//         xDataRef.value = []
//         let slice = resSliceMap.value.get(timeDuration.value)
//         if (slice !== undefined && slice.length != 0) {
//             let zero = slice[0].timeStamp
//             for (let i = slice.length - 1; i >= 0; i--) {
//                 cpuUsage.value.push(JSON.parse(slice[i].totalPercent)[0])
//                 memoryUsage.value.push(slice[i].memoryUsedPercent)
//                 diskUsage.value.push(slice[i].diskUsedPercent)
//                 xDataRef.value.push(getTimeDisplay(zero - slice[i].timeStamp).toFixed(2))
//             }
//         }
//     }
// }

const webServerAddedProcess = async () => {
    let distance = distanceOfTimeDuration.get(timeDuration.value)
    if (distance !== undefined && infoDetails.value !== undefined) {
        let resSlice = await homeAPI.getServerInfoAdded(infoDetails.value.timeStamp)
        if (resSlice.length >= distance) {
            for (let i = resSlice.length - 1; i >= 0; i--) {
                if ((i + 1) % distance === 0) {
                    infoDetails.value = resSlice[i]
                    infoDetailsList.value = [resSlice[i]].concat(infoDetailsList.value)
                }
            }
            infoDetailsList.value = infoDetailsList.value.length > 13 ? infoDetailsList.value.slice(0, 13) : infoDetailsList.value
        }
    }
    setChartData13(infoDetailsList.value)
}

const getTimeDisplay = (time: number): number => {
    if (timeDuration.value === '5 minute') {
        return time / 60

    } else if (timeDuration.value === '1 hour') {
        return time / 60
    } else if (timeDuration.value === '0.5 day') {
        return time / 60 / 60
    } else if (timeDuration.value === '1 day') {
        return time / 60 / 60
    } else {
        return time
    }
}


onMounted(async () => {
    isLoading.value = true
    if (serverName.value === 'web server') {
        await webServerProcess()
    } else if (serverName.value === 'file server') {
        console.log('file server')
    }

    const cpuCharEle = document.getElementById('CPU usage') as HTMLElement;
    const cpuCharEch: echarts.ECharts = echarts.init(cpuCharEle);

    const memoryCharEle = document.getElementById('memory usage') as HTMLElement;
    const memoryCharEch: echarts.ECharts = echarts.init(memoryCharEle);

    const diskCharEle = document.getElementById('disk usage') as HTMLElement;
    const diskCharEch: echarts.ECharts = echarts.init(diskCharEle);

    await initCharts('CPU usage', cpuCharEch, cpuUsage.value)
    await initCharts('memory usage', memoryCharEch, memoryUsage.value)
    await initCharts('disk usage', diskCharEch, diskUsage.value)

    isLoading.value = false

    intervalId.value = setInterval(async () => {
        if (serverName.value === 'web server') {
            await webServerAddedProcess()
        } else if (serverName.value === 'file server') {
            console.log('file server')
        }

        await initCharts('CPU usage', cpuCharEch, cpuUsage.value)
        await initCharts('memory usage', memoryCharEch, memoryUsage.value)
        await initCharts('disk usage', diskCharEch, diskUsage.value)
    }, 30000)

    window.onresize = () => {
        cpuCharEch.resize()
        memoryCharEch.resize()
        diskCharEch.resize()
    };
})

watch(serverName, async (newValue: any, oldValue: any) => {
    if (serverName.value === 'web server') {
        await webServerProcess()
    } else if (serverName.value === 'file server') {
        console.log('file server')
    }
})

watch(timeDuration, async (newValue: any, oldValue: any) => {
    if (serverName.value === 'web server') {
        await webServerProcess()
    } else if (serverName.value === 'file server') {
        console.log('file server')
    }

    const cpuCharEle = document.getElementById('CPU usage') as HTMLElement;
    const cpuCharEch = echarts.getInstanceByDom(cpuCharEle) as echarts.ECharts
    const memoryCharEle = document.getElementById('memory usage') as HTMLElement;
    const memoryCharEch = echarts.getInstanceByDom(memoryCharEle) as echarts.ECharts
    const diskCharEle = document.getElementById('disk usage') as HTMLElement;
    const diskCharEch = echarts.getInstanceByDom(diskCharEle) as echarts.ECharts

    cpuCharEch.clear()
    memoryCharEch.clear()
    diskCharEch.clear()

    await initCharts('CPU usage', cpuCharEch, cpuUsage.value)
    await initCharts('memory usage', memoryCharEch, memoryUsage.value)
    await initCharts('disk usage', diskCharEch, diskUsage.value)
})


const initCharts = async (chartName: string, charEch: echarts.ECharts, data: number[]) => {
    const option: echarts.EChartsOption = {
        title: {
            text: chartName,
            left: 'center'
        },
        xAxis: {
            name: xAxisNameMap.get(timeDuration.value),
            type: 'category',
            data: xAxisDataMap.get(timeDuration.value),
        },
        yAxis: {
            type: 'value',
            max: 100,
            min: 0,
            interval: 20,
        },
        series: [
            {
                data: getSlice(data),
                type: 'line'
            }
        ]
    };
    charEch.setOption(option);

}

const getSlice = (data: number[]): number[] => {
    let len = data.length;
    let targetLen = 13
    if (len < targetLen) {
        let slice: number[] = [];
        for (let i = 0; i < (targetLen === undefined ? 13 : targetLen) - len; i++) {
            slice.push(0)
        }
        slice = slice.concat(data)
        return slice
    } else if (len > targetLen) {
        return data.slice(len - targetLen, data.length)
    } else {
        return data
    }
}

onUnmounted(() => {
    cpuUsage.value = []
    memoryUsage.value = []
    diskUsage.value = []
    clearInterval(intervalId.value)
    intervalId.value = 0
})




return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_text, null, {
        default: _withCtx(() => [
          _createTextVNode("选择服务器： "),
          _createVNode(_component_el_select, {
            modelValue: serverName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serverName).value = $event)),
            placeholder: "Select"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_text, null, {
        default: _withCtx(() => [
          _createTextVNode("时间范围： "),
          _createVNode(_component_el_select, {
            modelValue: timeDuration.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((timeDuration).value = $event)),
            placeholder: "Select"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeDurationOptions, (item) => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_descriptions, {
          direction: "vertical",
          column: 5,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "HostName" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(infoDetails.value?.hostName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "bootTime" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(infoDetails.value === undefined ? "" : _unref(changeToDateTime)(infoDetails.value.bootTime)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "uptime" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(infoDetails.value === undefined ? "0s" :
                        _unref(changeToTime)(infoDetails.value.upTime)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_descriptions, {
        title: "详细信息",
        direction: "vertical",
        column: 1,
        size: "large",
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "CPU" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions, {
                column: 2,
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, {
                    label: "modelName:",
                    span: 2
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value?.modelName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, {
                    label: "usage:",
                    span: 2
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 :
                            JSON.parse(infoDetails.value.totalPercent)[0].toFixed(2)) + "%", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "phyCount:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value?.phyCount), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "logicCount:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value?.logicCount), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "Memory" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions, {
                column: 2,
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "usage:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 : infoDetails.value.memoryUsedPercent.toFixed(2)) + "%", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "total:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 :
                            _unref(GetFileSize)(infoDetails.value.memoryTotal)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "free:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 :
                            _unref(GetFileSize)(infoDetails.value.memoryAvailable)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "used:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 :
                            _unref(GetFileSize)(infoDetails.value.memoryUsed)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { label: "Disk" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions, {
                column: 2,
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "usage:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 : infoDetails.value.diskUsedPercent.toFixed(2)) + "%", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "total:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 :
                            _unref(GetFileSize)(infoDetails.value.diskTotal)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "free:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 :
                            _unref(GetFileSize)(infoDetails.value.diskFree)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "used:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 :
                            _unref(GetFileSize)(infoDetails.value.diskUsed)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "readRate:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 : _unref(GetFileSize)(infoDetails.value.readRate)) + "/s", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "writeRate:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(infoDetails.value === undefined ? 0 : _unref(GetFileSize)(infoDetails.value.writeRate)) + "/s", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})